import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from "react-intl";
import ConsignmentSupplier from './ConsignmentSupplier';

const ConsignmentSupplierWrapper: FC = () => {

  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Nhà cung cấp ký gửi</PageTitle>
      <ConsignmentSupplier />
    </>
  )
}

export default ConsignmentSupplierWrapper
